import firebase from "firebase";
import {
	FIREBASE_CREATE_USER,
	FIREBASE_SIGNIN_GOOGLE,
	FIREBASE_SIGNIN_FACEBOOK,
	FIREBASE_SIGNIN_APPLE,
	FIREBASE_SEND_FORGOT_PWD,
	FIREBASE_VALIDATE_PHONE_NO,
	FIREBASE_VERIFY_PASSWORD_RESET,
} from '@/store/actions.type';

const state = {};

const actions = {
	[FIREBASE_CREATE_USER] ({ commit, dispatch }, data) {
		return firebase.auth().createUserWithEmailAndPassword(data.email, data.password).then(
			(result) => {
				if (result.user && result.user.emailVerified === false) {
					result.user.sendEmailVerification().then(function () {
					});
				}

				return true;
			},
			(err) => {
				if(err && err.code == 'auth/email-already-in-use'){
					return true;
				}else {
					return false;
				}
			});
	},
	[FIREBASE_SIGNIN_GOOGLE] ({ commit, dispatch }) {
		const provider = new firebase.auth.GoogleAuthProvider();
		return firebase.auth().signInWithPopup(provider).then(result => {
			var socialLoginObj = {};
			socialLoginObj.providerUserId = result.additionalUserInfo.profile.id;
			socialLoginObj.email = result.additionalUserInfo.profile.email;
			socialLoginObj.name = result.additionalUserInfo.profile.name;
			socialLoginObj.providerId = 3;

			return socialLoginObj;
		})
			.catch(err => {

				return null;
			});
	},
	[FIREBASE_SIGNIN_FACEBOOK] ({ commit, dispatch }) {
		const provider = new firebase.auth.FacebookAuthProvider();
		return firebase.auth().signInWithPopup(provider).then(result => {
			var token = result.credential.accessToken;
			var user = result.user;
			var socialLoginObj = {};
			socialLoginObj.name = user.displayName;
			socialLoginObj.email = user.email;
			socialLoginObj.providerUserId = user.uid;
			socialLoginObj.providerId = 4;

			return socialLoginObj;
		})
			.catch(err => {
				return null;
			});
	},
	[FIREBASE_SIGNIN_APPLE] ({ commit, dispatch }) {
		const provider = new firebase.auth.OAuthProvider('apple.com');
		provider.addScope('email');
		provider.addScope('name');
		return firebase.auth().signInWithPopup(provider).then(result => {
			var token = result.credential.accessToken;
			var user = result.user;
			var socialLoginObj = {};
			socialLoginObj.name = user.displayName;
			socialLoginObj.email = user.email;
			socialLoginObj.providerUserId = user.uid;
			socialLoginObj.providerId = 5;

			return socialLoginObj;

			return result;
		})
			.catch(err => {
				return null;
			});
	},
	[FIREBASE_SEND_FORGOT_PWD] ({ commit, dispatch }, data) {
		const actionCodeSettings = {
			url: 'http://localhost:8080/#/psiverify',
			handleCodeInApp: false
		};
		return firebase.auth().sendPasswordResetEmail(data.email, actionCodeSettings).then(result => {
			return true;

		}).catch(err => {
			return false;
		});
	},
	[FIREBASE_VALIDATE_PHONE_NO] ({ commit, dispatch }, data) {
		var captchContainer = document.getElementById('recaptcha-container');
		if (captchContainer != null)
			captchContainer.remove();
		var captchDiv = document.createElement('div');
		captchDiv.id = 'recaptcha-container';
		captchDiv.style.display = 'none';
		document.body.appendChild(captchDiv);

		const appVerifier = new firebase.auth.RecaptchaVerifier(
			'recaptcha-container',
			{
				size: 'invisible',
				callback: function (response) {
				},
				'expired-callback': function () {
				}
			}
		);

		return firebase.auth().signInWithPhoneNumber(data.phonenumber, appVerifier).then(confirmationResult => {
			confirmationResult.success = true;

			return confirmationResult;
		}).catch(err => {
			var result = { 'success': false };
			return result;
		});
	},
};

const mutations = {};

const gets = {};

export default {
	state,
	actions,
	mutations,
	gets
};



// WEBPACK FOOTER //
// ./src/store/modules/firebaseauth.js